import type { ReactNode } from 'react'
import { FRAME_OVERLAY_HOST_ID } from './FrameOverlay'

/**
 * Desktop shows the app centered in a phone-shaped frame (`prototype/index.html`'s
 * `.phone-frame`); a real mobile viewport is edge-to-edge because the OS chrome already
 * frames it (`global.css`'s `max-width: 600px` breakpoint). The prototype's decorative fake
 * status bar (clock, signal bars) is not ported — it read as mockup chrome, not product.
 */
export function PhoneFrame({ children }: { readonly children: ReactNode }): JSX.Element {
  return (
    <div className="app-shell">
      <div className="app-frame">
        {/* `id` is `FrameOverlay`'s portal target: a screen's own modal anchors to the frame,
          not to the scroll container it happens to be rendered inside. */}
        <div className="app-frame-inner" id={FRAME_OVERLAY_HOST_ID}>
          {children}
        </div>
      </div>
    </div>
  )
}
